export const dynamicLinks = [
  {
    id: 1,
    url: 'about',
    path: 'about'
  },
  {
    id: 2,
    url: 'discover',
    path: 'discover'
  },
  {
    id: 3,
    url: 'services',
    path: 'services'
  },
  {
    id: 4,
    url: 'wallet',
    path: 'wallet'
  },
  {
    id: 5,
    url: 'testimonials',
    path: 'testimonials'
  }
];
